import { DOMAINS } from './common.consts';

interface ExternalEmbedSandboxOptions {
  readonly allowPopupsToEscapeSandbox?: boolean;
  readonly embedderOrigin?: string | null;
}

function isOwnedHost(hostname: string): boolean {
  const host = hostname.replace(/\.+$/, '');

  return (
    host === DOMAINS.LOCALHOST ||
    host.endsWith(`.${DOMAINS.LOCALHOST}`) ||
    host === DOMAINS.MAIN ||
    host.endsWith(`.${DOMAINS.MAIN}`)
  );
}

function isExternalOrigin(src: string, embedderOrigin: string | null): boolean {
  try {
    const { protocol, hostname, origin } = new URL(src);
    if (protocol !== 'https:' && protocol !== 'http:') {
      return false;
    }

    return embedderOrigin ? origin !== embedderOrigin : !isOwnedHost(hostname);
  } catch {
    return false;
  }
}

export function getExternalEmbedSandbox(
  src: string,
  {
    allowPopupsToEscapeSandbox = false,
    embedderOrigin = null,
  }: ExternalEmbedSandboxOptions = {}
): string {
  return [
    'allow-scripts',
    isExternalOrigin(src, embedderOrigin) && 'allow-same-origin',
    'allow-forms',
    'allow-popups',
    allowPopupsToEscapeSandbox && 'allow-popups-to-escape-sandbox',
  ]
    .filter(Boolean)
    .join(' ');
}
